import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { ConversationsMentionContext } from 'src/components/bbc-atlaskit-editor';
import { MentionsBuildArgs } from 'src/components/editor/providers/recommendations-mentions-provider';
import { useIntl } from 'src/hooks/intl';
import { getConversationsMentionsContext } from 'src/selectors/conversation-selectors';
import {
  getCurrentRepositoryOwnerName,
  getCurrentRepositorySlug,
} from 'src/selectors/repository-selectors';

type MentionProvider = MentionsBuildArgs & {
  conversationsMentionContext: ConversationsMentionContext;
};

export const useMentionProviderProps = (): MentionProvider => {
  const intl = useIntl();
  const conversationsMentionContext = useSelector(
    getConversationsMentionsContext
  );
  const owner = useSelector(getCurrentRepositoryOwnerName) || '';
  const slug = useSelector(getCurrentRepositorySlug) || '';

  const props = useMemo(
    () => ({ intl, conversationsMentionContext, owner, slug }),
    [intl, conversationsMentionContext, owner, slug]
  );

  return props;
};
